var qiniuUrl = "https://upload.qiniup.com";
var sid = 3;
const version = "v24.2.3.3.0";

var host = "";

function Api(api) {
  this.api = api;
}

Api.prototype.httpUrl = function () {
  return host + this.api;
};

Api.prototype.wssApi = function () {
  return this.api;
};

function getWssHost(){
    var hostname = window.location.hostname;
    var protocol = window.location.protocol;
  hostname = (-1!=hostname.indexOf("127") || -1!=hostname.indexOf("localhost")) ? "xmiss.yunlaimi.com": hostname;
  //protocol = "https:"==protocol ? "wss:":"ws:";
  protocol = "wss:";
  return protocol+"//"+hostname;
}

var api = {
    //传递用户信息code
    host: host,
    wssHost: getWssHost(),
    sid: sid,
    version: version,
    qiniuUrl: qiniuUrl,

    loginUrl: host + '/api/account/login',
    getnames: host + '/api/account/getnames',
    //获取登录信息
    getaccount: host + '/api/sass/getaccount',
    //根据门店获取相应信息(粉丝、订单等)
    getstoreinfo: host + 'api/sass/store/getstoreinfo',
    //登出
    logout: host + '/api/account/logout',
    // 获取上传图片token
    getuptoken: host + '/api/upload/getuptoken',
    // 获取验证码
    verifycode: host + '/api/verifycode/get',
    //代理商设备列表
    listsbyagentid:host +'/api/sass/props/listsbyagentid',
    //设备列表(根据拥有者-集团、门店)
    listsbyowner:host + '/api/sass/props/listsbyowner',
    //超级管理员全部屏幕列表
    superlist:host + '/api/sass/props/lists',
     //解绑初始化屏幕
     resetbinding:host + '/api/sass/props/resetbinding',
    //添加设备
    addscreen: host + '/api/sass/props/create',
    //修改设备
    setscreen: host + '/api/sass/props/update',
    //批量导入设备
    addmorescreen: host + '/api/sass/props/batchimport',
    //经销商列表
    agentlist:host + '/api/sass/agentsub/list',
    //集团列表
    grouplist: host + '/api/sass/agentsub/list',
    //代理商分配设备给经销商、集团
    bindingmerchants:host + '/api/sass/props/bindingmerchants',
    //集团分配设备给门店
    bindingstore: host + '/api/sass/props/bindingstore',
    //设备分配交易单列表(转给别人)
    propsordertootherslist:host + '/api/sass/propsorder/propsordertootherslist',
    //设备交易单列表
    propsorderlist:host + '/api/sass/propsorder/propsorderlist',
    //设备交易单明细列表
    propsorderdetaillist:host + '/api/sass/propsorderdetail/propsorderdetaillist',
    //App管理列表
    applist:host + '/api/sass/appversion/list',
    //添加App版本
    addapp:host + '/api/sass/appversion/create',
    //修改App版本
    setapp:host + '/api/sass/appversion/update',
    //修改App版本状态
    appupdatestatus:host + '/api/sass/appversion/updatestatus',
     //获取当前代理商
    getcurrentagent:host + '/api/sass/agent/getcurrentagent',
     //根据设备分配交易单统计设备使用状态数量
    getusedcountbypoid:host + '/api/sass/propsorder/getusedcountbypoid',

    agentsearch: host + '/api/sass/agentsub/list', //搜索经销商、集团客户、门店客户

    getscreeninfo: host + '/api/sass/props/getcountinfo', //设备管理首页数据

    //根据商品ID加载商品列表信息
    selectgoodslistbyoids:host + '/api/xmiss/goods/selectgoodslistbyoids',
    //设备分配交易单明细列表(转给他人)
    propsorderdetailtootherslist:host + '/api/sass/propsorderdetail/propsorderdetailtootherslist',
    //显示设备模版内容
    showpropstemplatecontent:host + '/api/sass/propstemplate/showpropstemplatecontent',
    //商品详情
    commercialgoods:host + '/api/xmiss/goods/commercialgoods',
    //根据模版ID显示设备模版
    showpropstemplate:host + '/api/sass/propstemplate/showpropstemplate',
    //根据模版ID显示设备模版分类商品
    showpropstemplateclassifygoods:host + '/api/sass/propstemplate/showpropstemplateclassifygoods',
    //已转出设备总数信息
    getrolloutpropsnum:host + '/api/sass/propsorder/getrolloutpropsnum',
    //集团撤回给门店的设备
    cancelbindingstore:host + '/api/sass/props/cancelbindingstore',

    //通过tid单点登录
    loginbytid:host+'/api/sass/loginbyredis',

    //获取图片验证码
    getimagecode: host + '/api/verifycode/imageget',
  };

module.exports = api;



//////////////////
// WEBPACK FOOTER
// ./static/js/url-config.js
// module id = /Gi/
// module chunks = 1 2 3